.component {
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: var(--light-grey);
}
